<template>
  <div class="blood-pressure-page">
    <!-- 顶部导航栏 - 参考 bloodOxygen 页面 -->
    <header class="blood-pressure-header" :style="{paddingTop: statusBarHeight + 'px'}">
      <div class="header-background">
        <img src="@/assets/personalInformation/headbackground.png" alt="背景" class="header-bg-img" />
      </div>
      <div class="header-nav">
        <button 
          class="nav-back-btn" 
          @click="goBack"
          :style="{top: (statusBarHeight + 12) + 'px'}"
        >
          <i class="el-icon-arrow-left"></i>
        </button>
        <div class="nav-title">血压</div>
        <div class="nav-placeholder"></div>
      </div>
    </header>

    <!-- 内容区域 -->
    <div class="blood-pressure-content" :style="{paddingTop: (statusBarHeight + 80) + 'px'}">
      <!-- 血压趋势图卡片 - 参考 bloodOxygen 页面结构 -->
      <div class="bp-chart-card">
        <div class="bp-chart-header">
          <div class="bp-chart-title">
            <i class="bp-chart-icon"></i>
            <span>血压趋势图</span>
          </div>
          <div class="bp-chart-date" @click="timeClick()">
            {{ displayDate }}
            <i class="el-icon-caret-bottom"></i>
          </div>
        </div>
        <div class="health-chart-content">
          <div ref="chart" class="health-chart"></div>
        </div>
        <div class="health-chart-lengend">
          <div class="hcl-item">
            <span class="hcl-theme1"></span>
            <p>收缩压</p>
          </div>
          <div class="hcl-item">
            <span class="hcl-theme2"></span>
            <p>舒张压</p>
          </div>
        </div>
          <!-- 血压状况卡片 -->
        <div class="bp-status-card">
          <div class="bp-status-title">
            <i class="bp-status-icon"></i>
            <span>血压状况</span>
          </div>
          <div class="bp-status-values">
            <div class="bp-status-item">
              <div class="bp-status-label">收缩压 mmHg</div>
              <div class="bp-status-value">{{ name || '--' }}</div>
            </div>
            <div class="bp-status-item">
              <div class="bp-status-label">舒张压 mmHg</div>
              <div class="bp-status-value">{{ name2 || '--' }}</div>
            </div>
          </div>
        </div>

      </div>

     
      <!-- 统计模块 -->
      <div class="health-statistics">
        <div class="hs-title">
          <i class="hs-icon"></i>
          <span>每日统计</span>
        </div>
        <div class="hs-content">
          <div class="hs-cell van-hairline--bottom">
            <div class="hsc-label">平均收缩压</div>
            <div class="hsc-value">{{ avgHi || '--' }}mmHg</div>
          </div>
          <div class="hs-cell van-hairline--bottom">
            <div class="hsc-label">平均舒张压</div>
            <div class="hsc-value">{{ avgLow || '--' }}mmHg</div>
          </div>
          <div class="hs-cell van-hairline--bottom">
            <div class="hsc-label">最高收缩压</div>
            <div class="hsc-value">{{ hi || '--' }}mmHg</div>
          </div>
          <div class="hs-cell">
            <div class="hsc-label">最高舒张压</div>
            <div class="hsc-value">{{ low || '--' }}mmHg</div>
          </div>
        </div>
      </div>
    
      <!-- 血压仪设备测量结果 -->
      <div class="health-device-card" v-if="bloodPressureMonitorData.length > 0">
        <div class="hd-title">
          <i class="hd-device-icon"></i>
          <span>血压仪设备测量结果</span>
        </div>
        <div class="hd-device-info-card">
          <div class="hd-device-image-wrapper">
            <!-- <div class="hd-device-status-dot"></div> -->
            <img src="@/assets/bloodPressure/Frame_4407@2x.png" alt="血压仪" class="hd-device-image" />
          </div>
          <div class="hd-device-text-info">
            <div class="hd-device-name">{{ bloodPressureMonitorData[0].deviceTypeName || '血压仪' }}</div>
            <div class="hd-device-sn">设备编号: {{ bloodPressureMonitorData[0].deviceSn }}</div>
          </div>
        </div>
        <div v-for="(record, index) in bloodPressureMonitorData" :key="index" class="hd-device-measurement">
          <div class="hd-measurement-block">
            <div class="hd-measurement-time">
              <span class="hd-measurement-time-label">测量时间</span>
              <span class="hd-measurement-time-value">{{ formatMeasureTimeDisplay(record.measureTime) }}</span>
            </div>
            <div class="hd-measurement-item van-hairline--bottom">
              <span class="hd-measurement-label">收缩压</span>
              <span class="hd-measurement-value">{{ record.sbp }}mmHg</span>
            </div>
            <div class="hd-measurement-item van-hairline--bottom">
              <span class="hd-measurement-label">舒张压</span>
              <span class="hd-measurement-value">{{ record.dbp }}mmHg</span>
            </div>
            <div class="hd-measurement-item">
              <span class="hd-measurement-label">心率</span>
              <span class="hd-measurement-value">{{ record.pulseRate }}次/分</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 无血压仪数据提示 -->
      <div class="health-device-card" v-if="bloodPressureMonitorData.length === 0 && !monitorLoading">
        <div class="hd-title">
          <i class="hd-device-icon"></i>
          <span>血压仪设备测量结果</span>
        </div>
        <div class="hd-no-data">
          <div class="hd-no-data-text">暂无血压计测量数据</div>
        </div>
      </div>

      <!-- 说明模块 -->
      <div class="health-desp">
        <div class="hd-title">
          <i class="hd-icon"></i>
          <span>血压</span>
        </div>
        <div class="hd-content">
          <p>血压指血液在血管内流动时作用于单位面积血管壁的侧压力，它是推动血液在血管内流动的动力。一般正常血压的范围：</p>
          <p class="hd-reference-item">90mmHg ≤ 收缩压 &lt; 140mmHg</p>
          <p class="hd-reference-item">60mmHg &lt; 舒张压 &lt; 90mmHg</p>
        </div>
      </div>

      <!-- 免责声明 -->
      <div class="health-disclaimer">
        <p>注:非医疗设备,结果仅供参考,如有不适,请及时就医</p>
      </div>
    </div>
    <picke @child-method="parentMethod" :value="value"></picke>
  </div>
</template>
<script>
import { mapState } from 'pinia';
import { useGlobalStore } from '@/stores/global';
import * as echarts from "echarts";
import { bloodpre, queryBloodPressureMonitor } from "@/api/activity";
export default {
  name: 'bloodPressure',
  computed: {
    ...mapState(useGlobalStore, ['statusBarHeight']),
    /**
     * 格式化显示的日期
     */
    displayDate() {
      if (this.time && this.time !== '1') {
        // 如果 time 是日期格式，转换为显示格式
        const dateStr = this.time.replace(/年/g, '/').replace(/月/g, '/').replace(/日/g, '');
        const date = new Date(dateStr);
        if (!isNaN(date.getTime())) {
          const year = date.getFullYear();
          const month = date.getMonth() + 1;
          const day = date.getDate();
          const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
          const week = weekDays[date.getDay()];
          return `${year}年${month}月${day}日 ${week}`;
        }
      }
      if (this.newtime && this.week) {
        return `${this.newtime} ${this.week}`;
      }
      return '';
    },
  },
  data() {
    return {
      avgLow: "",
      avgHi: "",
      low: "",
      hi: "",
      data: [],
      data1: [],
      nameData: [],
      progress: 100,
      echartsTime: "",
      name: "0",
      name2: "0",
      time: "1",
      time1: "2",
      newtime: "",
      value: false,
      week: "",
      chartInstance: null,
      timeIndex:-1,
      // 血压仪设备数据
      bloodPressureMonitorData: [],
      monitorAvgData: {
        avgSbp: null,
        avgDbp: null,
        avgPulseRate: null
      },
      monitorLoading: false,
    };
  },
  components: {
    picke: () => import("@/components/picke"),
  },
  mounted() {
    document.title = "血压趋势";
    if(localStorage.getItem('oldAge') == 1) {
          document.getElementById("html").style.fontSize = "48px";
        }
    // 设置 body 背景色，确保滚动时背景色不丢失
    document.body.style.backgroundColor = '#F2F3F5';
    // 初始化血压仪数据
    this.getBloodPressureMonitorData();
  },
  beforeDestroy() {
    // 恢复 body 背景色
    document.body.style.backgroundColor = '';
    // 在组件销毁前移除resize事件监听
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    /**
     * 返回上一页
     */
    goBack() {
      this.$router.go(-1);
    },
    getData() {
      var obj = {
        type: 1,
        dat: this.getTransferTime(this.transferTime(this.time)),
      };
      bloodpre(obj).then((res) => {
        if (res.code == 1000) {
          if (res.data != undefined) {
            this.avgHi = res.data.avgHi || 0;
            this.avgLow = res.data.avgLow || 0;
            this.hi = res.data.hi || 0;
            this.low = res.data.low || 0;
            if (res.data.detailTimes) {
              res.data.detailTimes[res.data.detailTimes.length] = "24:00"
              this.nameData = res.data.detailTimes;
              var diyi = 0;
              for (let i = res.data.lowDetails.length - 1; i >= 0; i--) {
                if (res.data.lowDetails[i] == 0) {
                  res.data.lowDetails[i] = null;
                  res.data.hiDetails[i] = null;
                }
               
                if (diyi == 0) {
                  if (res.data.lowDetails[i] != 0) {
                    diyi = 1;
                    this.echartsTime = res.data.detailTimes[i];
                    this.name = res.data.hiDetails[i];
                    this.name2 = res.data.lowDetails[i];
                  }
                }
              }
              for(let i = 0; i < res.data.lowDetails.length; i++) {
                if(res.data.lowDetails[i] != null && res.data.lowDetails[i] != 0) {
                  this.timeIndex = i
                }
              }
              this.data = res.data.lowDetails;
              for (var i = 0; i < res.data.hiDetails.length; i++) {
                if (res.data.hiDetails[i] != null) {
                  res.data.hiDetails[i] = res.data.hiDetails[i] - res.data.lowDetails[i];
                }
              }
              this.data1 = res.data.hiDetails;
              // this.echartsTime = this.nameData[0];
              // this.name = this.data1[0];
              // this.name2 = this.data[0];
            } else {
              this.nameData = [];
              this.data1 = [];
              this.data = [];
            }
          } else {
            this.avgHi = 0;
            this.avgLow = 0;
            this.hi = 0;
            this.low = 0;
            this.nameData = [];
            this.data1 = [];
            this.data = [];
          }

          this.initChart(this.timeIndex);
        }
        console.log(res.data);
      });
    },
    getTransferTime(data) {
      let str = data.replace(/\//g, "-");
      return str;
    },
    timeLeft() {
      this.week = this.getWeek(
        this.timestampToDateFormat1(
          this.convertDateToTimestamp(this.transferTime(this.time)) - 86400000
        )
      );
      this.leftTime =
        this.convertDateToTimestamp(this.transferTime(this.time)) - 86400000;
      this.time = this.timestampToDateFormat2(this.leftTime);
      this.newtime = this.timestampToDateFormat(this.leftTime);
      this.getData()
      console.log(this.timestampToDateFormat(this.leftTime));
      //console.log(this.leftTime)
      // console.log(this.week)
    },
    convertDateToTimestamp(dateString) {
      var parts = dateString.split("/");
      // 新 Date(年, 月 [, 日 [, 时 [, 分 [, 秒 [, 毫秒]]]]]) 中的月份是从0开始的，所以需要减1
      var date = new Date(parts[0], parts[1] - 1, parts[2]);
      return date.getTime();
    },
    timestampToDateFormat(timestamp) {
      const dateObj = new Date(timestamp); // 创建Date对象
      const year = dateObj.getFullYear(); // 获取年份
      const month = ("0" + (dateObj.getMonth() + 1)).slice(-2); // 获取月份，并补零
      const day = ("0" + dateObj.getDate()).slice(-2); // 获取日期，并补零

      return `${month}月${day}日`; // 返回转换后的日期格式
    },
    timestampToDateFormat1(timestamp) {
      const dateObj = new Date(timestamp); // 创建Date对象
      const year = dateObj.getFullYear(); // 获取年份
      const month = ("0" + (dateObj.getMonth() + 1)).slice(-2); // 获取月份，并补零
      const day = ("0" + dateObj.getDate()).slice(-2); // 获取日期，并补零

      return `${year}/${month}/${day}`; // 返回转换后的日期格式
    },
    timestampToDateFormat2(timestamp) {
      const dateObj = new Date(timestamp); // 创建Date对象
      const year = dateObj.getFullYear(); // 获取年份
      const month = ("0" + (dateObj.getMonth() + 1)).slice(-2); // 获取月份，并补零
      const day = ("0" + dateObj.getDate()).slice(-2); // 获取日期，并补零

      return `${year}年${month}月${day}日`; // 返回转换后的日期格式
    },
    timeRight() {
      this.week = this.getWeek(
        this.timestampToDateFormat1(
        this.convertDateToTimestamp(this.transferTime(this.time)) + 86400000
        )
      );
      this.leftTime =
        this.convertDateToTimestamp(this.transferTime(this.time)) + 86400000;
      this.time = this.timestampToDateFormat2(this.leftTime);
      this.newtime = this.timestampToDateFormat(this.leftTime);
      console.log(this.timestampToDateFormat(this.leftTime));
      this.getData()
    },
    renderCardList(data) {
      console.log(data);
      this.echartsTime = data[0].name;
      if(data[1].value != undefined) {
        this.name = data[1].value + data[0].value;
      }else {
        this.name = ''
      }
      this.name2 = data[0].value;
    },
    initChart(timeIndex) {
      const chartDom = this.$refs.chart;
      this.chartInstance = echarts.init(chartDom);
      const option = {
        title: {},
        tooltip: {
          trigger: "axis",
          extraCssText: "z-index: -1",
          axisPointer: {
            type: "line",
            lineStyle: {
              color: "red", // 修改线型指示器的颜色为红色
              width: 1, // 指示器线宽
              type:'solid'
            },
            
          },
          formatter: (params) => {
            console.log(params);
            let obj = params;
            // this.renderCardList处理对应数据
            this.renderCardList(obj);
          },
          clickable: true,
        },
        legend: {
          show: false,
        },
        toolbox: {
          feature: {
            saveAsImage: null,
          },
        },
        grid: {
          x: 15,
          y: 15,
          x2: 30,
          y2: 20,
        },
        // xAxis: {
        //   type: "category",
        //   boundaryGap: false,
        //   data: this.nameData,
        //   clickable: true,
        // },
    xAxis: {
        type: 'category',
        data:  this.nameData,
        axisTick: {
            alignWithLabel: true,
            interval: function (index, value) {
                return ['00:00', '06:00', '12:00', '18:00', '24:00'].includes(value);
            }
        },
        axisLabel: {
            interval: function (index, value) {
                return ['00:00', '06:00', '12:00', '18:00', '24:00'].includes(value);
            }
        }
    },
        yAxis: {
          type: "value",
          scale: true,
          position: "right",
          alignTicks: true,
          axisLine: {
            show: true,
          },
        },
        series: [
          {
            name: "Email",
            type: "line",
            smooth: true,
            stack: "Total",
            showSymbol: false,
            normal: {
              color: "#5470DE", // 圆点颜色
              lineStyle: {
                color: "#5470DE", // 线条颜色
              },
            },

            data: this.data,
          },
          {
            name: "Union Ads",
            type: "line",
            smooth: true,
            stack: "Total",
            showSymbol: false,

            normal: {
              color: "#07BEAA", // 圆点颜色
              lineStyle: {
                color: "#07BEAA", // 线条颜色
              },
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  // 渐变颜色
                  {
                    offset: 0,
                    color: "#E3EFFE",
                  },
                  {
                    offset: 1,
                    color: "#E5F9FD",
                  },
                ],
                global: false,
              },
            },
            data: this.data1,
          },
        ],
      };

      this.chartInstance.setOption(option);
      if (timeIndex !== -1) {
          // 显示图标指示器
          this.chartInstance.dispatchAction({
            type: 'showTip',
            seriesIndex: 0,
            dataIndex: timeIndex
          });
        };
      window.addEventListener("resize", this.handleResize);
    },
    handleResize() {
      this.chartInstance.resize();
    },
    timeClick() {
      this.value = !this.value;
      console.log(this.value);
    },
    parentMethod(msg) {
      this.time = msg;
      this.week = this.getWeek(this.transferTime(this.time));
      let originalString = msg;
      this.newtime = originalString.slice(5);
      // this.name = this.data[0];
      // this.name2 = this.data1[0];
      this.getData();
      // 日期改变时同时更新血压仪数据
      this.getBloodPressureMonitorData();
    },
    transferTime(data) {
      let str = data;
      let regex = /年/g; // 使用正则表达式并设置全局标志g
      let regex1 = /月/g; // 使用正则表达式并设置全局标志g
      var newStr = str.replace(regex, "/"); // 替换所有的"World"为"Earth"
      var newStr2 = newStr.replace(regex1, "/"); // 替换所有的"World"为"Earth"
      return newStr2.slice(0, -1);
    },
    getWeek(dateStr) {
      var date = ""; //周几
      let weeks = {
        1: "星期一",
        2: "星期二",
        3: "星期三",
        4: "星期四",
        5: "星期五",
        6: "星期六",
        0: "星期日",
      };
      date = new Date(dateStr);
      let weekIndex = date.getDay();
      date = weeks[weekIndex];
      return date;
    },
    /**
     * 获取血压仪设备测量数据
     */
    getBloodPressureMonitorData() {
      this.monitorLoading = true;
      // 将当前选择的日期转换为yyyy-MM-dd格式
      const queryDate = this.getTransferTime(this.transferTime(this.time));
      
      const params = {
        queryType: "SINGLE_DAY",
        queryDate: queryDate
      };
      
      queryBloodPressureMonitor(params).then((res) => {
        this.monitorLoading = false;
        if (res.code == 1000) {
          if (res.data && res.data.data) {
            this.bloodPressureMonitorData = res.data.data;
            this.monitorAvgData = {
              avgSbp: res.data.avgSbp,
              avgDbp: res.data.avgDbp,
              avgPulseRate: res.data.avgPulseRate
            };
          } else {
            this.bloodPressureMonitorData = [];
            this.monitorAvgData = {
              avgSbp: null,
              avgDbp: null,
              avgPulseRate: null
            };
          }
        } else {
          this.bloodPressureMonitorData = [];
          this.monitorAvgData = {
            avgSbp: null,
            avgDbp: null,
            avgPulseRate: null
          };
        }
      }).catch((error) => {
        this.monitorLoading = false;
        console.error('获取血压计数据失败:', error);
        this.bloodPressureMonitorData = [];
        this.monitorAvgData = {
          avgSbp: null,
          avgDbp: null,
          avgPulseRate: null
        };
      });
    },
    /**
     * 格式化测量时间（仅时分，用于图表等）
     * @param {string} measureTime - 测量时间，格式：yyyy-MM-dd HH:mm:ss
     * @returns {string} 格式化后的时间，格式：HH:mm
     */
    formatMeasureTime(measureTime) {
      if (!measureTime) return '';
      const date = new Date(measureTime);
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${hours}:${minutes}`;
    },
    /**
     * 格式化测量时间用于列表展示（日期+时分）
     * @param {string} measureTime - 测量时间，格式：yyyy-MM-dd HH:mm:ss
     * @returns {string} 格式化后的时间，格式：yyyy-MM-dd HH:mm
     */
    formatMeasureTimeDisplay(measureTime) {
      if (!measureTime) return '--';
      const date = new Date(measureTime);
      if (isNaN(date.getTime())) return '--';
      const y = date.getFullYear();
      const m = (date.getMonth() + 1).toString().padStart(2, '0');
      const d = date.getDate().toString().padStart(2, '0');
      const h = date.getHours().toString().padStart(2, '0');
      const min = date.getMinutes().toString().padStart(2, '0');
      return `${y}-${m}-${d} ${h}:${min}`;
    },
  },
};
</script>
<style lang="less" scoped>
* {
  padding: 0;
  font-family: "微软雅黑";
}

/* 页面包装器 */
.blood-pressure-page {
  position: relative;
  min-height: 100vh;
  background: #F2F3F5;
  padding-bottom: 20px;
  
  /* 确保背景色覆盖整个页面，包括滚动区域 */
  &::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #F2F3F5;
    z-index: -1;
    pointer-events: none;
  }
}

/* 头部样式 - 参考 bloodOxygen 页面 */
.blood-pressure-header {
  position: relative;
  width: 100%;
  min-height: 220px;
  overflow: hidden;
  margin-bottom: 0;
}

.header-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.header-bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.header-nav {
  position: relative;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  min-height: 44px;
}

.nav-back-btn {
  position: fixed;
  left: 16px;
  z-index: 1000;
  width: 28px;
  height: 28px;
  padding: 0;
  background: #ffffff;
  border: none;
  border-radius: 50%;
  color: #000000;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.nav-back-btn i {
  font-size: 16px;
  font-weight: 600;
  color: #000000;
}

.nav-back-btn:hover {
  background: #f5f5f5;
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.nav-back-btn:active {
  transform: translateY(0) scale(0.95);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.nav-title {
  flex: 1;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: #000000;
}

.nav-placeholder {
  flex-shrink: 0;
  width: 28px;
}

/* 内容区域 */
.blood-pressure-content {
  width: 100%;
  padding: 16px;
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
  z-index: 10;
  background-color: transparent;
}

/* 血压趋势图卡片 */
.bp-chart-card {
  padding: 16px;
  margin: 0 0 16px 0;
  background-image: url('~@/assets/bloodPressure/Rectangle_853@2x (1).png');
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 12px;
  overflow: hidden;
}

.bp-chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.bp-chart-title {
  display: flex;
  align-items: center;
  
  .bp-chart-icon {
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-right: 8px;
    background-image: url('~@/assets/bloodPressure/Frame_3003@2x (1).png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    flex-shrink: 0;
  }
  
  span {
    font-size: 15px;
    font-weight: 500;
    color: #000000;
  }
}

.bp-chart-date {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #000000;
  cursor: pointer;
  
  i {
    margin-left: 4px;
    font-size: 14px;
    color: #666666;
    flex-shrink: 0;
  }
}

/* 图表容器样式 */
.health-chart-content {
  border: 1px solid #F0F0F0;
  border-radius: 10px;
  padding: 16px;
  background: #FFFFFF;
  margin: 0 0 16px 0;
}

.health-chart {
  width: 100%;
  height: 192px;
}

/* 图例样式 */
.health-chart-lengend {
  display: flex;
  justify-content: center;
  gap: 32px;
  margin-top: 8px;
  
  .hcl-item {
    display: flex;
    align-items: center;
    height: 14px;
    
    span {
      display: block;
      width: 20px;
      height: 8px;
      border-radius: 4px;
      &.hcl-theme1 {
        background: #5470DE; // 收缩压 蓝色
      }
      &.hcl-theme2 {
        background: #07BEAA; // 舒张压 青色
      }
    }
    
    p {
      margin-left: 4px;
      font-size: 13px;
      color: #151515;
    }
  }
}

/* 血压状况卡片 */
.bp-status-card {
  margin: 15px 0 16px 0;
}

.bp-status-title {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  
  .bp-status-icon {
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-right: 8px;
    background-image: url('~@/assets/bloodPressure/Frame_3964@2x (4).png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    flex-shrink: 0;
  }
  
  span {
    font-size: 15px;
    font-weight: 500;
    color: #000000;
  }
}

.bp-status-values {
  display: flex;
  gap: 12px;
}

.bp-status-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 16px;
  background: #FFFFFF;
  border-radius: 12px;
  gap: 12px;
  height: 76px;
  box-sizing: border-box;
}

.bp-status-label {
  font-size: 12px;
  color: #666666;
  line-height: 1.2;
}

.bp-status-value {
  font-size: 20px;
  font-weight: bold;
  color: #000000;
  line-height: 1;
}

/* 统计模块样式 - 使用背景图 */
.health-statistics {
  margin: 0 0 16px 0;
  background-image: url('~@/assets/bloodPressure/Rectangle_853@2x (1).png');
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 12px;
  overflow: hidden;
  
  .hs-content {
    margin: 10px;
    background: #FFFFFF;
    border-radius: 10px;
  }
  
  .hs-title {
    display: flex;
    align-items: center;
    padding: 15px 16px 7px 16px;
    font-weight: bold;
    font-size: 15px;
    color: #333333;
    line-height: 18px;
    
    .hs-icon {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 8px;
      background-image: url('~@/assets/bloodPressure/Frame_3964@2x (5).png');
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      flex-shrink: 0;
    }
    
    span {
      flex: 1;
    }
  }
  
  .hs-cell {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 44px;
    padding: 0 16px;
    font-size: 14px;
    color: #000000;
    
    .hsc-label {
      font-size: 14px;
      color: #000000;
      font-weight: 400;
    }
    
    .hsc-value {
      font-size: 14px;
      color: #000000;
    }
  }
}

/* 血压仪设备测量结果卡片 */
.health-device-card {
  margin: 0 0 16px 0;
  background: linear-gradient(180deg, #fefce8 0%, #fffbeb 40%, #ffffff 100%);
  border-radius: 12px;
  padding: 16px;
  overflow: hidden;
  
  .hd-title {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    font-weight: bold;
    font-size: 15px;
    color: #333333;
    
    .hd-device-icon {
      display: inline-block;
      width: 20px;
      height: 20px;
      margin-right: 8px;
      background-image: url('~@/assets/bloodPressure/Frame_3964@2x (6).png');
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      flex-shrink: 0;
    }
    
    span {
      flex: 1;
    }
  }
  
  .hd-device-info-card {
    display: flex;
    align-items: center;
    padding: 16px;
    margin-bottom: 16px;
    background: #FFFFFF;
    border-radius: 6px;
    position: relative;
  }
  
  .hd-device-image-wrapper {
    position: relative;
    margin-right: 16px;
    flex-shrink: 0;
  }
  
  .hd-device-status-dot {
    position: absolute;
    top: -4px;
    left: 50%;
    transform: translateX(-50%);
    width: 8px;
    height: 8px;
    background: #00C275;
    border-radius: 50%;
    z-index: 1;
  }
  
  .hd-device-image {
    width: auto;
    height: 60px;
    display: block;
  }
  
  .hd-device-text-info {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  
  .hd-device-name {
    font-size: 15px;
    font-weight: bold;
    color: #000000;
    margin-bottom: 8px;
  }
  
  .hd-device-sn {
    font-size: 12px;
    color: #666666;
  }
  
  .hd-device-measurement {
    margin-bottom: 12px;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
  
  /** 单次测量记录区块：区分每次测量 */
  .hd-measurement-block {
    background: #FFFFFF;
    border-radius: 8px;
    padding: 12px 16px;
    margin-bottom: 0;
  }
  
  /** 测量时间行 */
  .hd-measurement-time {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
    margin-bottom: 8px;
    border-bottom: 1px solid #F0F0F0;
  }
  
  .hd-measurement-time-label {
    font-size: 13px;
    color: #666666;
  }
  
  .hd-measurement-time-value {
    font-size: 14px;
    font-weight: 600;
    color: #333333;
  }
  
  .hd-measurement-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 44px;
    padding: 0;
    
    .hd-measurement-label {
      font-size: 14px;
      color: #000000;
    }
    
    .hd-measurement-value {
      font-size: 14px;
      color: #000000;
      font-weight: 400;
    }
  }
  
  .hd-no-data {
    padding: 20px 0;
    text-align: center;
    
    .hd-no-data-text {
      font-size: 14px;
      color: #999999;
    }
  }
}

/* 说明模块样式 */
.health-desp {
  margin: 0 0 16px 0;
  background-image: url('~@/assets/bloodPressure/Rectangle_853@2x (3).png');
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 12px;
  padding: 16px;
  overflow: hidden;
  
  .hd-title {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    font-weight: bold;
    font-size: 15px;
    color: #333333;
    
    .hd-icon {
      display: inline-block;
      width: 20px;
      height: 20px;
      margin-right: 8px;
      background-image: url('~@/assets/bloodPressure/Frame_3964@2x (7).png');
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      flex-shrink: 0;
    }
    
    span {
      flex: 1;
    }
  }
  
  .hd-content {
    padding: 16px;
    background: #FFFFFF;
    border-radius: 12px;
    
    p {
      font-size: 14px;
      color: #000000;
      line-height: 21px;
      text-align: justify;
      margin-bottom: 8px;
      
      &:last-child {
        margin-bottom: 0;
      }
    }
    
    .hd-reference-item {
      margin-bottom: 6px;
    }
  }
}

/* 免责声明 */
.health-disclaimer {
  text-align: center;
  padding: 12px 0;
  font-size: 12px;
  color: #999999;
  line-height: 1.5;
}

.time {
  font-size: 15px;
  color: #636363;
  text-align: center;
}

.down-arrow:after {
  content: "";
  display: block;
  width: 0px;
  height: 0px;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 10px solid #666666;
  margin-top: 10px;
}
.totalBox {
  width: 93%;
  height: 84px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 10px;
  margin-top: 16px;
  padding: 10px 10px;
}
.numberTitle {
  font-family: HiraginoSansGB, HiraginoSansGB;
  font-weight: normal;
  font-size: 22px;
  color: #333333;
  line-height: 33px;
  text-align: center;
  font-style: normal;
}
.nameTitle {
  font-family: HiraginoSansGB, HiraginoSansGB;
  font-weight: normal;
  font-size: 13px;
  color: #999999;
  line-height: 20px;
  text-align: center;
  font-style: normal;
}
.defeat {
  width: 100%;
  height: 64px;
  background: #f3f3f3;
  border-radius: 10px;
  /* margin-top: 16px; */
  display: flex;
  /* justify-content: center;  */
  align-items: left;
}
.drop {
  width: 8px;
  height: 8px;
  background: #209f66;
  border-radius: 100%;
  margin: 0px 10px;
  position: absolute;
  top: 18px;
  left: 2px;
}
.defeatName {
  height: 64px;

  font-family: HiraginoSansGB, HiraginoSansGB;
  font-weight: normal;
  font-size: 16px;
  color: #333333;
  text-align: left;
  font-style: normal;
  /* display: flex; */
  /* justify-content: center; */
  /* align-items: center;  */
  margin-left: 10px;
  padding-left: 28px;
  position: relative;
}
.paceTiele {
  width: 93%;
  /* height: 215px; */
  margin: 0 auto;
  background: #ffffff;
  border-radius: 10px;
  margin-top: 16px;
  padding: 12px 0px;
}
.reachTheStandardTitle {
  font-family: HiraginoSansGB, HiraginoSansGB;
  font-weight: 800;
  font-size: 16px;
  color: #333333;
  line-height: 24px;
  text-align: left;
  font-style: normal;
  padding-left: 16px;
}
.total {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #000000;
  text-align: left;
  font-style: normal;
  height: 43px;
  line-height: 43px;
  padding-left: 16px;
  border-bottom: 1px solid #e5e5e5;
  position: relative;
  /* margin-top: 5px; */
}
.thisWeek {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #000000;
  text-align: left;
  font-style: normal;
  height: 43px;
  line-height: 43px;
  padding-left: 16px;
  margin-top: 8px;
}
.lastweek {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #000000;
  text-align: left;
  font-style: normal;
  height: 43px;
  line-height: 43px;
  padding-left: 16px;
  margin-top: 8px;
}
.continuous {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #000000;
  text-align: left;
  font-style: normal;
  height: 43px;
  line-height: 43px;
  padding-left: 16px;
  margin-top: 5px;
  position: relative;
}
.day {
  /* float: right;
  margin-right: 8px; */
  position: absolute;
  right: 6px;
  font-size: 14px;
  color: #151515;
}
.weeklySteps {
  margin-top: 16px;
  width: 93%;
  height: 238px;
  background: #ffffff;
  border-radius: 10px;
  padding: 12px 5px;
}
.progressDiv {
  width: 92%;
  margin-top: 1.5px;
  position: relative;
}
.progress-bar {
  width: 100%;
  background-color: #e5e5e5;
  border-radius: 50px;
  overflow: hidden;
}

.progress {
  height: 5px;
  background: linear-gradient(231deg, #00c275 0%, #00b5ba 100%);
  border-radius: 50px;
  /* transition: width 1s ease; */
  margin-left: 0 !important;
}
.last {
  height: 5px;
  background: linear-gradient(231deg, #ffa94a 0%, #ff8e32 100%) !important;
  border-radius: 50px;
  margin-left: 0 !important;
}
.lastDay {
  width: 8px;
  height: 8px;
  background: #ffffff;
  border: 2px solid #ff9315 !important;
  border-radius: 100%;
  position: absolute;
  top: -1.5px;
}
.progressDay {
  width: 8px;
  height: 8px;
  background: #ffffff;
  border: 2px solid #00c275;
  /* transition: width 1s ease; */
  border-radius: 100%;
  position: absolute;
  top: -1.5px;
}
.ssy {
  font-family: HiraginoSansGB, HiraginoSansGB;
  font-weight: normal;
  font-size: 13px;
  color: #151515;
  line-height: 20px;
  text-align: center;
  font-style: normal;
}
.yaliDiv {
  display: flex;
  padding: 0 50px;
}
.xieya {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #000000;
  line-height: 21px;
  text-align: justify;
  font-style: normal;
  padding: 10px 15px;
}

/* 血压仪设备测量结果样式 */
.device-info {
  padding: 12px 16px;
  background: #f3f3f3;
  border-radius: 10px;
  margin: 10px 16px;
  position: relative;
}

.device-info::before {
  content: "";
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
  height: 8px;
  background: #209f66;
  border-radius: 100%;
}

.device-name {
  font-family: HiraginoSansGB, HiraginoSansGB;
  font-weight: 600;
  font-size: 15px;
  color: #333333;
  margin-bottom: 4px;
  padding-left: 20px;
}

.device-sn {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #999999;
  padding-left: 20px;
}

.monitor-avg {
  margin-top: 8px;
}

.monitor-records {
  margin-top: 8px;
  max-height: 300px;
  overflow-y: auto;
}

.record-item {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #000000;
  text-align: left;
  font-style: normal;
  padding: 12px 16px;
  border-bottom: 1px solid #e5e5e5;
  position: relative;
}

.record-item:last-child {
  border-bottom: none;
}

.record-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.record-time {
  font-size: 14px;
  color: #333;
  font-weight: 600;
  line-height: 1.2;
}

.record-battery {
  font-size: 12px;
  color: #999;
  line-height: 1.2;
}

.record-content {
  display: flex;
  align-items: center;
}

.record-values {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.sbp {
  font-size: 16px;
  font-weight: 600;
  color: #e74c3c;
  line-height: 1.2;
}

.pulse {
  font-size: 14px;
  color: #666;
  line-height: 1.2;
}

.arrhythmia-warning {
  background: #ff6b6b;
  color: white;
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: normal;
  line-height: 1.2;
  margin-left: 8px;
}

.no-data {
  text-align: center;
  padding: 40px 20px;
}

.no-data-text {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #999999;
  margin-bottom: 8px;
}
</style>


// WEBPACK FOOTER //
// src/views/bloodPressure/index.vue